import React from 'react';
import { LineLayer as BaseLayer } from './LineLayer';

const FillLayer = React.forwardRef(function FillLayer(props, ref) {
  return <BaseLayer type="fill" ref={ref} {...props} />;
});

export { FillLayer };
